<template>
  <!-- 主页 -->
  <div class="box1">
    <div>
      <el-row class="search_box" type="flex" justify="center">
        <el-input id="sousuo" prefix-icon="el-icon-search" placeholder="请输入关键字" @keyup.enter.native="go()"
                  v-model="input"
                  class="user_input"></el-input>
        <!-- <el-button type="primary" icon="el-icon-search"  class="btn">搜索</el-button> -->
      </el-row>
      <el-row>
        <img class="index_img" src="../assets/index.png" alt="" srcset="">
      </el-row>
      <el-row type="flex" justify="space-around">
        <div class="title text">
          <div @click="goBasicsUnread" class="plan">
            <p>学习计划</p>
            <span class="color">{{ basicsUnread.length + this.gmdss.mustLearnVideo }}</span>份
          </div>
          <div style="width:10%"></div>
          <div @click="goStatutesUnread" class="plan">
            <p>法规学习</p>
            <span class="color">{{ statutesUnread.length }}</span>份
          </div>
        </div>
      </el-row>
    </div>
    <div class="xuanze" style="margin-top: 0.5rem">
      <div class="box">
        <h3 class="title">船员安全</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.menu_limit.indexOf(branch_id) === -1 && item.main_id.indexOf('|1|') != -1">
              <div class="menu2" @click="file_Btn(item,3)">{{ item.menu }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <h3 class="title">视频专区</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.menu_limit.indexOf(branch_id) === -1 && item.main_id.indexOf('|2|') != -1">
              <div class="menu2" @click="file_Btn(item,2)">{{ item.menu }}</div>
              <div style="width:20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.branch_id === 1" class="box">
        <h3 class="title">甲板业务</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.main_id.indexOf('|3|') != -1">
              <div class="menu2" @click="file_Btn(item,3)">{{ item.menu }}</div>
              <div style="width:20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.branch_id === 2" class="box">
        <h3 class="title">轮机业务</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.main_id.indexOf('|4|') != -1">
              <div class="menu2" @click="file_Btn(item,3)">{{ item.menu }}</div>
              <div style="width:20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <h3 class="title">岸基业务</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.main_id=='|5|'">
              <div class="menu2" @click="file_Btn(item,3)">{{ item.menu }}</div>
              <div style="width:20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <h3 class="title">新规及通知</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.main_id.indexOf('|6|') != -1">
              <div class="menu2" @click="file_Btn(item,3)">{{ item.menu }}</div>
              <div style="width:20px"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="box">
        <h3 class="title">实用工具</h3>
        <div class="menu">
          <div style="color:#0af" v-for="(item,q) in menuList" :key="q">
            <div v-if="item.main_id.indexOf('|7|') != -1">
              <div class="menu2" @click="file_Btn(item,3)">{{ item.menu }}</div>
              <div style="width:20px"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      // 搜索的2个数据类型
      folder2: {list: []},
      folder3: {list: []},
      branch: '',
      menuId: '',
      menuName: '',
      mainId: '',
      menu: '',
      menuList: '',
      input: '',
      // 学习计划
      study: '',
      // 考核项目
      examine: '',
      // 法规学习
      statute: '',
      deck: false,
      turbine: false,
      branch_id: '',
      // 基础未读
      basicsUnread: [],
      // 考核未读
      assessUnread: [],
      // 法规未读
      statutesUnread: []
    }
  },
  watch: {
    keyWord: function (newVal, oldVal) {
      if (this.keyWord !== undefined && this.keyWord !== '') {
        let key = newVal
        this.getListByKeyWord(key)
      }
    },
    '$route': function (val) {
      if (val.path === '/index') {
        this.getUnreadList()
        // 反复进入学习计划退出
        this.getbooksRead(this.gmdss.user_info.id)
      }
    }
  },
  created () {
    this.getToken()
  },
  mounted () {
    this.getMenuList()
    // this.getbranch_id()
  },
  computed: {
    folder: function () {
      if (this.mainId === '|2|') {
        return 'video'
      } else if (this.mainId === '|7|') {
        return 'tool'
      }
    }
  },
  methods: {
    goBasicsUnread () {
      let data = this.basicsUnread
      if (data.length === 0 && this.gmdss.mustLearnVideo === 0) {
        this.$message('没有学习计划')
        return
      }
      window.$gmdss.basicsUnread = data
      this.gmdss.model = 1
      this.$router.push({path: '/file'})
    },
    goStatutesUnread () {
      let data = this.statutesUnread
      if (data.length !== 0) {
        window.$gmdss.statutes = data
        this.$router.push({path: '/file'})
        this.gmdss.model = 3
      } else {
        this.$message('没有法规学习')
      }
    },
    // 获取菜单
    getMenuList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getMenuListFn
      sendData.vm = this
      req.Post('menu/menu_list', sendData)
    },
    getMenuListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.menuList = data.list
    },
    // 获取整张试卷
    wholePaper () {
      let obj = {}
      obj.id = this.gmdss.station_id
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.wholePaperFn
      sendData.vm = this
      req.Post('exam/wholePaper', sendData)
    },
    wholePaperFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
      }
    },
    file_Btn (data, id) {
      this.mainId = data.main_id
      this.menuId = data.id
      this.menuName = data.menu
      this.firstGetSubmenuList(data)
      this.gmdss.model = id // 1 书本
    },
    // 进入路由获取数据
    firstGetSubmenuList (data) {
      let leixing = ''
      if (data.main_id === '|2|') {
        leixing = 'video'
      } else if (data.main_id === '|7|') {
        leixing = 'tool'
      }
      let type = leixing
      type = parseInt(type)
      // 显示所有未读列表进入
      if (type) {
        this.submenuList = this.gmdss.getUnreadByType(type)
        return
      }
      // 通过菜单进来, 判断是要获取书本类还是视频工具类
      let mainId = data.main_id.split('|')[1]
      if (mainId !== '2' && mainId !== '7') {
        // 获取书本类
        this.getListByMenuId()
      } else {
        // 获取视频工具类
        let filter = {}
        filter.menu_id = data.id
        let folder = leixing
        this.getFolderList(filter, folder)
      }
    },
    getListByKeyWord (keyWord) {
      let filter = {}
      let now = parseInt(new Date().getTime() / 1000)
      let info = this.gmdss.user_info
      filter.job = info.station_id
      filter.begin = now
      filter.end = now
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      filter.file_name = keyWord
      filter.remove = 0
      this.getFolderList2(filter, 'video') // 搜索视频
      this.getFolderList2(filter, 'tool') // 搜索工具
      this.getSubmenuList(filter) // 搜索书本
    },
    getListByMenuId () {
      let menuId = this.menuId
      let mainId = this.mainId
      let filter = {}
      filter.menu_id = menuId
      filter.remove = 0
      let now = parseInt(new Date().getTime() / 1000)
      let info = this.gmdss.user_info
      filter.job = info.station_id
      filter.begin = now
      filter.end = now
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      // 查找的是基本业务类型还是法规
      if (mainId !== '|6|') {
        filter.type = 1
      } else {
        filter.type = 3
      }
      this.getSubmenuList(filter)
    },
    // 获取视频和工具
    // filter: 筛选条件 folder 文件夹名 'video' 或 'tool'
    getFolderList2 (filter, folder) {
      let obj = {}
      obj.folder = folder
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getFolderListFn2
      sendData.vm = this
      req.Post('fileMenuData/get_file', sendData)
    },
    getFolderListFn2 (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      let folder = data.folder
      this[folder] = data.list
      if (folder === 'tool') {
        window.$gmdss.file2 = data
        this.folder2 = data
      } else {
        window.$gmdss.file3 = data
        this.folder3 = data
      }
    },
    getFolderList (filter, folder) {
      let obj = {}
      obj.folder = folder
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getFolderListFn
      sendData.vm = this
      req.Post('fileMenuData/get_file', sendData)
    },
    getFolderListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      if (data.list.length === 0) {
        this.$message('暂时没有内容')
        return
      }
      let folder = data.folder
      this[folder] = data.list
      window.$gmdss.file = data
      window.$gmdss.file.folder = folder
      if (data.folder === 'video') {
        window.$gmdss.video = data.list
      }
      this.$router.push({path: '/file'})
    },
    getSubmenuList (filter) {
      let obj = {}
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getSubmenuListFn
      sendData.vm = this
      req.Post('ship_train/post', sendData)
    },
    getSubmenuListFn (data) {
      if (data === null) {
        this.$message('网络连接失败')
        return
      }
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }

      this.submenuList = data.list
      if (data.list.length === 0 && this.folder2.list.length === 0 && this.folder3.list.length === 0) {
        this.$message('暂时没有内容')
      } else {
        if (this.gmdss.model === 3 && data.list.length === 0) {
          this.$message('暂时没有内容')
          return
        }
        window.$gmdss.file = data
        window.$gmdss.file2 = this.folder2
        window.$gmdss.file3 = this.folder3
        this.$router.push({path: '/file'})
      }
    },
    go () {
      if (event.keyCode === 13) {
        var a = document.getElementById('sousuo').value
        this.gmdss.model = 4 // 搜索模式
        // 按关键字请求一遍, 按video和tool分别请求工具一遍
        this.getListByKeyWord(a)
      }
    },
    getToken () {
      let token = window.$gmdss.token
      if (token === '') {
        window.location.href = './'
      } else {
        this.getUserData(token)
      }
    },
    // 获取用户视频已播放记录
    getUserPlayed (id) {
      let msg = {}
      msg.id = id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getUserPlayedFn
      sendData.vm = this
      req.Post('user/getUserPlayed', sendData)
    },
    getUserPlayedFn (data) {
      if (data.err_code !== 0) {
        return
      }
      // eslint-disable-next-line eqeqeq
      if (data.list == '[]' || data.list == null || data.list == 'null') {
        this.gmdss.videoReadList = []
        return
      }
      let list = []
      let obj = JSON.parse(data.list)
      obj.map((value) => {
        if (value) {
          list.push(value)
        }
      })
      this.gmdss.videoReadList = list
    },
    // 根据token获取用户信息
    getUserData (token) {
      let msg = {}
      msg.token = token
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getUserDatafn
      sendData.vm = this
      req.Post('user/analy_token', sendData)
    },
    getUserDatafn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      delete data.list.study_record
      this.gmdss.user_info = data.list
      this.branch_id = data.list.branch_id
      this.gmdss.station_id = data.list.station_id
      if (data.list.is_enter && this.gmdss.is_enter) {
        this.$router.push({path: '/required'})
        return
      }
      this.getbooksRead(data.list['id'])
      this.getUserPlayed(data.list['id'])
      this.getLearnList()
      this.countTheNumberOfVideos()
      this.wholePaper()
    },
    getbooksRead (id) {
      let msg = {}
      msg.id = id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.getbooksReadfn
      sendData.vm = this
      req.Post('user/getbooksRead', sendData)
    },
    // 重新拉去用户学习记录数据
    getbooksReadfn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.gmdss.user_info.study_record = data.list.study_record
      this.gmdss.user_info.learn_time = data.list.learn_time
    },
    // 获取还需要看的视频个数
    countTheNumberOfVideos () {
      let count = this.gmdss.user_info.station_id
      let id = this.gmdss.user_info.id
      let msg = {}
      msg.count = count
      msg.id = id
      let sendData = {}
      sendData.data = msg
      sendData.fn = this.countTheNumberOfVideosFn
      sendData.vm = this
      req.Post('user/countTheNumberOfVideos', sendData)
    },
    countTheNumberOfVideosFn (data) {
      if (data == null) {
        return
      }
      this.gmdss.mustLearnVideo = data.list
    },
    // 获取有效期的学习列表
    getLearnList () {
      let now = parseInt(new Date().getTime() / 1000)
      let info = this.gmdss.user_info
      let filter = {}
      filter.job = info.station_id
      filter.begin = now
      filter.end = now
      filter.belong_ship = info.serve_ship
      filter.branch_id = info.branch_id
      filter.remove = 0
      let obj = {}
      obj.filter = filter
      let sendData = {}
      sendData.data = obj
      sendData.fn = this.getLearnListFn
      sendData.vm = this
      req.Post('ship_train/post', sendData)
    },
    getLearnListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.learnList = data.list
      this.gmdss.learnList = data.list
      this.getUnreadList()
    },
    // 获取2个未读列表
    getUnreadList () {
      let typeList = this.gmdss.learnType
      this.basicsUnread = this.gmdss.getUnreadByType(typeList[0].id)
      this.gmdss.basicsUnread = this.basicsUnread
      this.statutesUnread = this.gmdss.getUnreadByType(typeList[2].id)
      this.gmdss.requiredData.statutesUnread = this.statutesUnread.length
      this.gmdss.requiredData.basicsUnread = this.basicsUnread.length
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getfile_id()
    })
  },
  // 路由跳出后
  beforeRouteLeave (to, from, next) {
    next()
  }
}
</script>

<style scoped>
.box {
  /* width: 24rem; */
  margin-top: 0.5rem;
  background-color: white;
  border-radius: 15px;
}

.menu {
  width: 20rem;
  display: flex;
  flex-wrap: wrap;
}

.menu2 {
  width: 10rem;
  text-align: center;
  border-top: solid 1px rgb(199, 197, 197);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.title {
  display: flex;
  margin-left: 1.5rem;
  /* height: 2.5rem; */
  padding: 0.5rem;
}

.hr {
  width: 100%;
  height: 1px;
  background-color: rgb(199, 197, 197);
}

.box1 {
  padding-bottom: 25%;
}

.xuanze {
  padding-left: 5%;
  padding-right: 5%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.kaPian {
  margin-top: 2rem;
  width: 5rem;
  margin: 0.9rem;
  text-align: center;
}

.user_input {
  margin: 0.5rem;
  width: 30rem;
}

.color {
  color: rgb(8, 150, 245);
}

.btn {
  margin: 0.5rem;
  height: 2.5rem;
}

.text {
  margin-top: 0.5rem;
}

.title {
  display: flex;
  font-size: 17px;
  width: 80%;
  text-align: center;
}

.plan {
  margin-right: 1.7rem;
  width: 10rem;
  padding: 1.2rem;
  background-color: white;
  border-radius: 15px;
  border: solid 1px rgb(46, 148, 250);
}

.search_box {
  background-color: rgb(62, 112, 214);
}

.index_img {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue